/**
 * 一括書込の 1 呼び出しあたりの上限。
 *
 * 性能の都合ではなく品質の機構である。仕様は後から誰も間違いに気づけない情報で、一度に
 * 大量の要素を生成させると後半ほど雑になる。1 回で作る量を人が目で追える大きさに抑え、
 * 間違いを持ち込む速度そのものを落とす。
 *
 * **3 件から 15 件へ上げた**（決定。2026-09-21）。業務 1 件は処理を 3〜11 件使うので、上限 3
 * のままだと業務 1 件を書くのに 2〜5 回の呼び出しが要る。上限の定数は 1 つで、一括の書込
 * すべてに当たる。「1 件でも検査に落ちれば 1 行も書かない」はそのままである。
 *
 * @graph-connects none
 */
export const WRITE_BATCH_LIMIT = 15;
// =============================================================================
// レスポンス（API §4.1 — 裁定 B-10 を決定 ab で更新した形）
// =============================================================================
/**
 * 変更ログ行から導出される変更の種別（HIST §6）。
 *
 * **`operation` 列は持たない**（裁定 B-3）。同一行から導出できる二次表現であり、
 * 保存すると矛盾した行が表現可能になるためである。
 *
 * @graph-stack spec-graph
 * @graph-domain Engineering
 * @graph-business 変更ログの before / after / previousId から導出される変更種別の allowlist
 * @graph-connects none
 */
export const DERIVED_OPERATIONS = ['create', 'update', 'delete', 'rename'];
//# sourceMappingURL=operations.js.map